// src/hooks/useMediaDevices.ts
import { useState, useEffect, useCallback } from 'react';

interface Device {
  id: string;
  label: string;
}

export const useMediaDevices = () => {
  const [videoDevices, setVideoDevices] = useState<Device[]>([]);
  const [audioDevices, setAudioDevices] = useState<Device[]>([]);

  const getDevices = useCallback(async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoInputs = devices.filter((d) => d.kind === 'videoinput');
      const audioInputs = devices.filter((d) => d.kind === 'audioinput');
      setVideoDevices(videoInputs.map((d) => ({ id: d.deviceId, label: d.label })));
      setAudioDevices(audioInputs.map((d) => ({ id: d.deviceId, label: d.label })));
    } catch (error) {
      console.error('Error enumerating devices:', error);
    }
  }, []);

  useEffect(() => {
    getDevices();
    navigator.mediaDevices.addEventListener('devicechange', getDevices);
    return () => {
      navigator.mediaDevices.removeEventListener('devicechange', getDevices);
    };
  }, [getDevices]);

  return { videoDevices, audioDevices, refreshDevices: getDevices };
};